import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 31 Jan 2026 1:28 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.gxo7h9C0f2UOfxk-3WlTfYwy9AKDZB2XPihajoTv-UcsncFLDlBF-ENmZeK2XKexbuzC-ws9Kf5Fq5uKMa2_qwMGA07Su3Bm-47hq6Hg-sG-IJHRA_Ueep_Wvgu8O3GbW9Hhi9zmN1M9RQYH4SJRlBKDdY-XB8je5O8hzSbdjwFnE4HMOonbvaJnePcHX4LqofOZ-EOPuZCMu542_Ybgggnxfp_m3XO_VdXOXLTfRk0tmO8vQUnI6TmvlJCVTAYmvHsh4gP3_RG9kGHM4tuq4yqt_Kjkjn_hiysXVAmEs4WEZgs2uIeYHNFbIpFOIC4qwuNpnSiDqd1WlLArU05__XuJavCUNs98EA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-07T00:28:47.801091Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-01-31T00:28:40+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.gxo7h9C0f2UOfxk-3WlTfYwy9AKDZB2XPihajoTv-UcsncFLDlBF-ENmZeK2XKexbuzC-ws9Kf5Fq5uKMa2_qwMGA07Su3Bm-47hq6Hg-sG-IJHRA_Ueep_Wvgu8O3GbW9Hhi9zmN1M9RQYH4SJRlBKDdY-XB8je5O8hzSbdjwFnE4HMOonbvaJnePcHX4LqofOZ-EOPuZCMu542_Ybgggnxfp_m3XO_VdXOXLTfRk0tmO8vQUnI6TmvlJCVTAYmvHsh4gP3_RG9kGHM4tuq4yqt_Kjkjn_hiysXVAmEs4WEZgs2uIeYHNFbIpFOIC4qwuNpnSiDqd1WlLArU05__XuJavCUNs98EA'

// {
//   "access_token": "v2.local.y6Us801aC-gum-nzolps8CHJaQITw8jwAaOAD4CX4Ox1SGZ8fZz3w7KjZoa2eeH-0hjwVsvj4fXGVQXloW1F90EhkeDPs5FLCWvF7wLfhIfLSVYnFDs7mUrblcjtCrq2YfzsLHeqj_bU7I9PMtH5Azj7mOfh5YxtnsMyJ3UArLUDrHfqVaUSvq7DWxUXcev580duK7LOYzZhmJ-eItSZ8FvBNw0l-8BL226ZXvYtlbTFM9o4HYOJgI7Od8dw-xnYpCL3Tn5pR2J5YffCWRvYCZIC0xNvMnuKkpdBf-8A0j3iwNetB1icqNAYT7zMPCAUToi6ILOsq31IksDDzD6TD51vlMf9",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-07T00:29:42.894190Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-01-31T00:29:37+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.y6Us801aC-gum-nzolps8CHJaQITw8jwAaOAD4CX4Ox1SGZ8fZz3w7KjZoa2eeH-0hjwVsvj4fXGVQXloW1F90EhkeDPs5FLCWvF7wLfhIfLSVYnFDs7mUrblcjtCrq2YfzsLHeqj_bU7I9PMtH5Azj7mOfh5YxtnsMyJ3UArLUDrHfqVaUSvq7DWxUXcev580duK7LOYzZhmJ-eItSZ8FvBNw0l-8BL226ZXvYtlbTFM9o4HYOJgI7Od8dw-xnYpCL3Tn5pR2J5YffCWRvYCZIC0xNvMnuKkpdBf-8A0j3iwNetB1icqNAYT7zMPCAUToi6ILOsq31IksDDzD6TD51vlMf9'

// {
//   "access_token": "v2.local.KTTy-_BM_jqB7oeBs9VIteY1iG7VnNdoBTCR7WhrRxmsTzh4p6pVJ53HEYq-Pdg-k7c_fCIkiz4k012xhOLPRnQQajfXYZjP4Vn28Z3BXTBFwM5j3IEG_lsb_iSIyNaPyCgT-g_RoSaS-OrKVRSuEyrc6SGS5wPmYzJazB_wx5L7UzqoJD3uHkkVVTV09AXwTSllzdt3gYhao127pcpKYByTb_KfM01gHjJcfyFp779SKoIFt7B7DeR4IYpm8RPV2CmjgDx2MbEQ6_HvoiQsBxiPaZPk2gNe4MXXkFckFcMJnduQBrJiAuVOZVqGL__ydGt2ZFYGQSLwHGETbNddmdjbgDE",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-07T00:30:43.893020Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.KTTy-_BM_jqB7oeBs9VIteY1iG7VnNdoBTCR7WhrRxmsTzh4p6pVJ53HEYq-Pdg-k7c_fCIkiz4k012xhOLPRnQQajfXYZjP4Vn28Z3BXTBFwM5j3IEG_lsb_iSIyNaPyCgT-g_RoSaS-OrKVRSuEyrc6SGS5wPmYzJazB_wx5L7UzqoJD3uHkkVVTV09AXwTSllzdt3gYhao127pcpKYByTb_KfM01gHjJcfyFp779SKoIFt7B7DeR4IYpm8RPV2CmjgDx2MbEQ6_HvoiQsBxiPaZPk2gNe4MXXkFckFcMJnduQBrJiAuVOZVqGL__ydGt2ZFYGQSLwHGETbNddmdjbgDE'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
